import { render, staticRenderFns } from "./SyncRules.vue?vue&type=template&id=15782efc&scoped=true"
import script from "./SyncRules.vue?vue&type=script&lang=js"
export * from "./SyncRules.vue?vue&type=script&lang=js"
import style0 from "./SyncRules.vue?vue&type=style&index=0&id=15782efc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15782efc",
  null
  
)

export default component.exports